import React from 'react'
import Images from '../Images'
import AuthActions from "../Containers/LoginPage/reducer";
import {useDispatch} from "react-redux";
import IconWithText from "./Text";
import Icon from "../Icon";

const LoginHeader = ({withLogout}) => {

  const dispatch = useDispatch();

  return (
    <div className="header-row">
      <img src={Images.logo} alt=""/>
      {
        withLogout &&
        <div style={{position: "absolute", right: '7.77vw', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer'}}>
          <IconWithText
            text={'Log out'}
            icon={() => <Icon type="logout" role="icon"/>}
            onClick={() => dispatch(AuthActions.logout())}
          />
        </div>
      }
    </div>
  )
}

LoginHeader.defaultProps = {
  withLogout: false
};

export default LoginHeader
